// let isDev = false;
// let isDev = true;

// const isDev = process.env.NODE_ENV === 'development';
const isDev = process.env.REACT_APP_IS_DEV === 'true';


class ConnUrls {
    static ApiUrl = isDev ? 'http://localhost:8000/api/' : 'https://api.napoleoncatering.co.il/api/';
    static mediasUrl = isDev ? 'http://localhost:3000' : 'https://api.napoleoncatering.co.il/';
    static mediasLocalUrl = isDev ? 'http://localhost:4001' : 'https://admin.napoleoncatering.co.il';
    // static servMediasUrl = isDev ? 'http://localhost:8000/images/' : 'https://lolaimgs.s3.eu-central-1.amazonaws.com/images/';
    static servMediasUrl = 'https://napoleonashdodimgs.s3.eu-central-1.amazonaws.com/images/';
    static socketClient = isDev ? 'http://localhost:9000/' : 'https://socket.napoleoncatering.co.il/';
}
export default ConnUrls; 